import { useGetAllPatientResourcesByID } from '_api';
import { useDeleteResourceSettingById } from '_api/mutations';
import { ResourceSetting } from '_api/types';
import { ThumbnailView } from 'components/atoms';
import { ActionsFlexBox, PatientProfileTable } from 'components/molecules';
import { MRT_ColumnDef } from 'material-react-table';
import React, { useMemo, useState } from 'react';

import { AddResourceToPatientProfileModal } from './modals/AddResourceToPatientProfileModal';
import { ProfileTableProps } from './types';

export const PatientResourceTable = ({ patientId }: ProfileTableProps) => {
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => setOpen(false);
  const { data: resources, isLoading: isResourceLoading } =
    useGetAllPatientResourcesByID(patientId);
  const { mutateAsync: deleteResource } = useDeleteResourceSettingById();

  const handleDeleteResourceOnClick = (id: number) => {
    deleteResource({ id });
  };

  const handleOnAddClick = () => {
    setOpen(true);
  };

  const resourceColumns = useMemo<MRT_ColumnDef<ResourceSetting>[]>(
    () => [
      {
        header: 'Resource',
        Cell: ({ row }) => (
          <ThumbnailView
            fullImageUrl={row.original.content.fullImageUrl}
            rowView={true}
          />
        ),
      },
      {
        header: 'Title',
        accessorFn: (row) => row.content.title,
      },
      {
        header: 'Actions',
        accessorFn: (row) => (
          <ActionsFlexBox
            msg={'resource'}
            deleteOnClick={() => handleDeleteResourceOnClick(row.id)}
            actionButtons={{
              deleteButton: true,
            }}
          />
        ),
        size: 10,
      },
    ],
    [],
  );

  return (
    <>
      {resources && !isResourceLoading ? (
        <PatientProfileTable
          columns={resourceColumns}
          data={resources}
          onAddClick={handleOnAddClick}
          title={'Resources'}
        />
      ) : null}
      <AddResourceToPatientProfileModal
        open={open}
        onClose={handleCloseModal}
        patientId={patientId}
      />
    </>
  );
};
